import { Constants } from "@dndbeyond/character-rules-engine/es";

import config from "~/config";

/**
 * Where the user is, sent as CHANGE_LOCATION. Premade pages share the
 * builder's app context, so they're told apart by their path.
 */
export const getChangeLocation = (
  context: Constants.AppContextTypeEnum | null,
  pathname: string
): string | null => {
  if (pathname.startsWith(`${config.basePathname}/premade`)) {
    return "premade_browse";
  }
  if (context === Constants.AppContextTypeEnum.BUILDER) {
    return "standard_builder";
  }
  if (context === Constants.AppContextTypeEnum.SHEET) {
    return "character_sheet";
  }
  return null;
};
